import { Flex, Text, Tooltip } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { faList } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList
} from '@morressier/alembic';

const nameLabel = {
  AssignSubmission: 'Assign Submission',
  CreateEditorialFormData: 'Create Editorial FormData',
  CreateSubmission: 'Create Submission',
  RequestRevision: 'Request Revision',
  'EditorialSubmissionDecision#accept': 'Accept Submision',
  'EditorialSubmissionDecision#approveForPeerReview': 'Approve for Peer Review',
  EditorialRejectSubmission: 'Reject',
  EditSubmission: 'Edit Submission',
  'PeerReviewDecision#acceptRequest': 'Accept Peer Review Request',
  'PeerReviewDecision#declineRequest': 'Decline Peer Review Request',
  RequestReview: 'Request Review',
  ResearchIntegrity: 'Research Integrity',
  SubmissionExport: 'Submission Export',
  UnassignSubmission: 'Unassign Submission',
  'SubmitRevision#fields': 'Respond to Comments',
  RequestSubmissionDeadlineExtension: 'Request Extension'
};

type ActionItem = {
  label?: string;
  description?: string;
  headingColor?: string;
  name: string;
  action: () => void;
};

const ContextMenu = ({
  actions,
  label = 'Actions'
}: {
  actions: ActionItem[];
  label?: string;
}) => {
  const triggerRef = useRef<HTMLSpanElement>(null);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  useEffect(() => {
    const closeTooltipOutsideTrigger = (event: Event) => {
      if (!triggerRef.current?.contains(event.target as Node)) {
        setIsTooltipOpen(false);
      }
    };

    document.addEventListener('pointerdown', closeTooltipOutsideTrigger, true);
    document.addEventListener('focusin', closeTooltipOutsideTrigger, true);
    return () => {
      document.removeEventListener('pointerdown', closeTooltipOutsideTrigger, true);
      document.removeEventListener('focusin', closeTooltipOutsideTrigger, true);
    };
  }, []);

  return (
    <Menu ariaLabel="normal menu">
      <Tooltip
        isOpen={isTooltipOpen}
        hasArrow
        shouldWrapChildren
        placement="top"
        label={label}
        borderRadius={4}
        data-cy="info-tooltip"
      >
        <span
          ref={triggerRef}
          onMouseEnter={() => setIsTooltipOpen(true)}
          onMouseLeave={() => setIsTooltipOpen(false)}
        >
          <MenuButton
            as={Button}
            variant="secondary"
            onClick={() => setIsTooltipOpen(false)}
          >
            <Flex gap={2} alignItems="center">
              <FontAwesomeIcon icon={faList} />
            </Flex>
          </MenuButton>
        </span>
      </Tooltip>
      <MenuList>
        {actions.map(action => (
          <MenuItem ariaLabel={action.name} onClick={action.action}>
            <Text textStyle="headingLine" color={action.headingColor}>
              {action.label ??
                nameLabel[action.name as keyof typeof nameLabel] ??
                action.name}
            </Text>

            {action.description && (
              <Text
                textStyle="headingOverline"
                maxW="300px"
                wordBreak={'break-word'}
              >
                {action.description}
              </Text>
            )}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default ContextMenu;
